import { create } from 'zustand';

interface AccountLinkedState {
  /** Provider that was just linked to the existing account, or null when nothing to show. */
  provider: string | null;
  show: (provider: string) => void;
  dismiss: () => void;
}

export const useAccountLinkedStore = create<AccountLinkedState>((set) => ({
  provider: null,
  show: (provider) => set({ provider }),
  dismiss: () => set({ provider: null }),
}));
